module.exports = __webpack_public_path__ + "img/colorful-v3-off.7064d47c.png";